import { z } from 'zod';
import { SURVEY_MAX_QUESTIONS, SurveyAnswerInput, SurveyEditorBlocks, SurveyQuestionInput, SurveyResponseOwnershipMode, } from './survey.js';
const IsoDateTime = z.string().datetime({ offset: true });
export const CreateSurveyRequest = z
    .object({
    title: z.string().min(1).max(180),
    description: SurveyEditorBlocks.nullable().optional(),
    audienceGroupId: z.string().uuid().nullable().optional(),
    anonymous: z.boolean().optional(),
    responseOwnershipMode: SurveyResponseOwnershipMode.optional(),
    oneResponsePerUser: z.boolean().optional(),
    maxResponsesPerUser: z.number().int().positive().nullable().optional(),
    requireLoginToSubmit: z.boolean().optional(),
    showSubmittedAnswers: z.boolean().optional(),
    publicResults: z.boolean().optional(),
    shuffleQuestions: z.boolean().optional(),
    opensAt: IsoDateTime.nullable().optional(),
    closesAt: IsoDateTime.nullable().optional(),
    responseCap: z.number().int().positive().nullable().optional(),
    questions: z.array(SurveyQuestionInput).max(SURVEY_MAX_QUESTIONS).optional(),
})
    .strict();
export const UpdateSurveyRequest = z
    .object({
    title: z.string().min(1).max(180).optional(),
    description: SurveyEditorBlocks.nullable().optional(),
    audienceGroupId: z.string().uuid().nullable().optional(),
    anonymous: z.boolean().optional(),
    responseOwnershipMode: SurveyResponseOwnershipMode.optional(),
    oneResponsePerUser: z.boolean().optional(),
    maxResponsesPerUser: z.number().int().positive().nullable().optional(),
    requireLoginToSubmit: z.boolean().optional(),
    showSubmittedAnswers: z.boolean().optional(),
    publicResults: z.boolean().optional(),
    shuffleQuestions: z.boolean().optional(),
    opensAt: IsoDateTime.nullable().optional(),
    closesAt: IsoDateTime.nullable().optional(),
    responseCap: z.number().int().positive().nullable().optional(),
    questions: z.array(SurveyQuestionInput).max(SURVEY_MAX_QUESTIONS).optional(),
})
    .strict();
export const PublishSurveyRequest = z
    .object({
    opensAt: IsoDateTime.nullable().optional(),
    closesAt: IsoDateTime.nullable().optional(),
})
    .strict();
export const SubmitSurveyResponseRequest = z
    .object({
    subjectUserId: z.string().uuid().optional(),
    startedAt: IsoDateTime.nullable().optional(),
    answers: z.array(SurveyAnswerInput).min(1).max(SURVEY_MAX_QUESTIONS),
})
    .strict();
export const ListSurveysQuery = z.object({
    q: z.string().trim().max(120).optional(),
    status: z.enum(['draft', 'scheduled', 'live', 'closed', 'archived']).optional(),
    audienceGroupId: z.string().uuid().optional(),
    includeDrafts: z.boolean().optional(),
    limit: z.number().int().min(1).max(100).optional(),
    offset: z.number().int().min(0).optional(),
});
export const SurveyParticipantFilterQuery = z.object({
    excludeParticipantUserIds: z.array(z.string().uuid()).max(500).optional(),
});
export const ListSurveyResponsesQuery = SurveyParticipantFilterQuery.extend({
    limit: z.number().int().min(1).max(500).optional(),
    offset: z.number().int().min(0).optional(),
});
export const SurveyExportQuery = z.object({
    format: z.enum(['json', 'csv', 'xlsx']).optional(),
}).merge(SurveyParticipantFilterQuery);
export const AttachSurveyEmbedRequest = z
    .object({
    articleId: z.string().uuid(),
})
    .strict();
//# sourceMappingURL=requests.js.map